import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectEditableFunctionalities = (store: StoreSchema) => {
    return store.functionalities.functionalitiesEditable
}
